export const styles = {
  titleBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '16px 0 -16px',
  },
};
